module.exports = __webpack_public_path__ + "static/media/21-2.f0d03bb3.mp3";